<script setup lang="ts">
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import DisplayOptionRow from "./DisplayOptionRow.vue";
import DisplaySectionLabel from "./DisplaySectionLabel.vue";
import { useDisplaySettings } from "@/composable/useDisplaySettings";
import { TOOLBAR_COLUMNS_MODES } from "@/utils/toolbar-layout";

/**
 * Section « Barre d'outils » : une ou deux colonnes. La description
 * n'explique que le choix en cours, pour rester courte.
 */
const { t } = useTranslation();
const { toolbarColumns } = useDisplaySettings();

const columnsOptions = computed(() =>
  TOOLBAR_COLUMNS_MODES.map((mode) => ({
    value: mode,
    label: t(`canvas:display.toolbarColumns.${mode}`),
  })),
);
</script>

<template>
  <div>
    <DisplaySectionLabel>{{
      $t("canvas:display.sections.toolbar")
    }}</DisplaySectionLabel>
    <DisplayOptionRow
      :title="$t('canvas:display.toolbarColumns.title')"
      :description="$t(`canvas:display.toolbarColumns.desc.${toolbarColumns}`)"
    >
      <el-segmented
        v-model="toolbarColumns"
        :options="columnsOptions"
        size="small"
        class="display-segmented"
        :aria-label="$t('canvas:display.toolbarColumns.title')"
      />
    </DisplayOptionRow>
  </div>
</template>
